import React from "react";
import Layout from "components/layout";
import { withI18next } from "lib/withI18next";
import SearchBlock from "components/search/SearchBlock";
import SearchBlock2 from "components/search/SearchBlock2";
import { page } from "components/page";
import ReactHtmlParser from "react-html-parser";
import { autobind } from "react-decoration";
import Link from "lib/Link";

@withI18next(["common"])
@page
class Sitemap extends React.Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  componentDidMount() {
    //console.log(this.props);
  }

  @autobind
  printSitemap(items, mainIndex) {
    let { i18n } = this.props;
    let { language } = i18n;
    let layout = [];
    if (items && items.length > 0) {
      layout.push(
        <ul>
          {items.map((item, index) => {
            let subLayout = [];
            let { url = "", name, en_name } = item;
            let showName = language === "en" && en_name ? en_name : name;
            if (url) {
              if (
                !url.startsWith("http://") &&
                !url.startsWith("https://") &&
                !url.startsWith("/")
              ) {
                url = "/" + url;
              }
            } else {
              url = "javascript:;";
            }
            let indexName = "" + (index + 1);
            if (mainIndex) {
              indexName = mainIndex + "." + indexName;
            }
            subLayout.push(
              <li>
                <Link href={url} title={showName}>
                  <span className="numb">{indexName}</span>
                  {ReactHtmlParser(showName)}
                </Link>
                {this.printSitemap(item.items, indexName)}
              </li>
            );
            return subLayout;
          })}
        </ul>
      );
    }
    return layout;
  }

  render() {
    let { layoutStyleType, appStore } = this.props;
    let { sitemap } = appStore;
    let items = [];
    if (sitemap) {
      items = sitemap.items;
    }
    return (
      <Layout {...this.props}>
        {layoutStyleType === "1" ? (
          <div className="main sp" id="center">
            <SearchBlock />
            <section className="main_content">
              <div className="container">
                <a
                  className="accesskey"
                  href="javascript:;"
                  id="aC"
                  accessKey="C"
                  title={this.props.t("jumperrwd.common.mainContenctArea")}>
                  :::
                </a>
                <h2>{this.props.t("jumperrwd.common.sitemap")}</h2>
                <a href="javascript:history.back();" className="back">
                  {this.props.t("hyint.common.table.back")}
                </a>
                <div className="detail_block">
                  <div className="article_content">
                    {ReactHtmlParser(
                      this.props.t("jumperrwd.common.sitemapContent")
                    )}
                  </div>
                </div>
              </div>
              {items.length > 0 && (
                <div className="container">
                  <div className="sitemap">
                    <section className="cascading">
                      {this.printSitemap(items, "")}
                    </section>
                  </div>
                </div>
              )}
            </section>
          </div>
        ) : layoutStyleType === "2" ? (
          <main className="main">
            <SearchBlock2 />
            <a
              className="accesskey"
              href="javascript:;"
              id="aC"
              accessKey="C"
              title={this.props.t("jumperrwd.common.mainContenctArea")}>
              :::
            </a>
            <div className="pageHeader">
              <h2>{this.props.t("jumperrwd.common.sitemap")}</h2>
            </div>
            <section className="sitemap">
              <article className="keyboardGuide">
                {ReactHtmlParser(
                  this.props.t("jumperrwd.common.sitemapContent")
                )}
              </article>
              <section className="cascading">
                {this.printSitemap(items, "")}
              </section>
            </section>
          </main>
        ) : (
          <></>
        )}
      </Layout>
    );
  }
}

export default Sitemap;
